import { BaseService } from './BaseService';

export interface EmailTemplateDto {
  templateKey: string;
  subject: string;
  htmlBody: string;
  isCustom: boolean;
}

export interface EmailTemplatePreview {
  subject: string;
  htmlBody: string;
}

export class EmailTemplateService extends BaseService {
  async getTemplates(tenantId: string): Promise<EmailTemplateDto[]> {
    return this.get<EmailTemplateDto[]>(`/email-templates?tenantId=${tenantId}`);
  }

  async updateTemplate(tenantId: string, templateKey: string, subject: string, htmlBody: string): Promise<void> {
    return this.put<void>(`/email-templates/${encodeURIComponent(templateKey)}`, { tenantId, subject, htmlBody });
  }

  async resetTemplate(tenantId: string, templateKey: string): Promise<void> {
    return this.post<void>(`/email-templates/${encodeURIComponent(templateKey)}/reset`, { tenantId });
  }

  async previewTemplate(templateKey: string, data: Record<string, string>): Promise<EmailTemplatePreview> {
    return this.post<EmailTemplatePreview>(`/email-templates/${encodeURIComponent(templateKey)}/preview`, data);
  }
}

export const emailTemplateService = new EmailTemplateService();
